<template>
  <Modal v-if="claimHistoricalData" :open="open" @close="closeModal">
    <div>
      <p class="block text-xl font-medium leading-6 text-gray-900">Status details</p>
      <span class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium">
        {{ $t(`claim.status.${claimHistoricalData.status}`) }}
      </span>

      <div class="bg-gray-100 p-5 mt-5">
        <p class="block text-sm font-medium leading-6 text-gray-900">Estaly Manager Notes</p>
        <p>{{ claimHistoricalData.internalNotes }}</p>
      </div>

      <div class="bg-gray-100 p-5 mt-5">
        <p class="block text-sm font-medium leading-6 text-gray-900">Claim Manager Notes</p>
        <p>{{ claimHistoricalData.customerMessage }}</p>
      </div>
    </div>
  </Modal>
</template>
<script>
import { Modal } from "@estaly/ui";

export default {
  components: { Modal },
  props: ["open", "claim", "claimHistoricalData"],

  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>
